import { Button, Card, message, Popconfirm, Space } from "antd";
import React, { useEffect, useState } from "react";
import { API_METHODS, BLANK_VALUE } from "../../constants";
import useApi from "../../hooks/useApi";
import TableComponent from "../common/table/TableComponent";
import AddNotice from "./AddNotice";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
function NoticeTable() {
  const [confirmDeletePCLoading, setConfirmDeletePCLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState();
  const [visibleEdit, setVisibleEdit] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState();
  const [deleteResponse, deleteRequest] = useApi();
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [messageApi, contextHolder] = message.useMessage();

  const columns = [
    {
      title: "Heading",
      dataIndex: "heading",
    },
    {
      title: "Notice",
      dataIndex: "notice",
    },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <>
          {
            <Space>
              <Button size="small" onClick={() => editRecord(record)}>
                <EditOutlined />
              </Button>
              <Popconfirm
                title="Delete Notice"
                description={`Are you sure to delete ${record.notice}?`}
                onConfirm={() => deleteOk(record)}
                trigger={"click"}
                okButtonProps={{
                  loading: confirmDeletePCLoading,
                }}
                placement="rightTop"
              >
                <Button size="small">
                  <DeleteOutlined style={{ color: "red" }} />
                </Button>
              </Popconfirm>
            </Space>
          }
        </>
      ),
    },
  ];

  const [responseData, getRequest] = useApi(
    `/admin/notice?pageNumber=${1}`,
    null,
    API_METHODS.GET
  );

  useEffect(() => {
    getRequest();
  }, []);

  useEffect(() => {
    const data = responseData.data !== BLANK_VALUE ? responseData.data : [];
    const pagination =
      responseData.pagination !== BLANK_VALUE ? responseData.pagination : {};
    setTableData(data);
    setTotalRecords(pagination ? pagination.count : 0);
  }, [responseData]);

  useEffect(() => {
    if (deleteResponse.data && !deleteResponse.isLoading) {
      getRequest();

      messageApi.open({
        type: "success",
        content: "Notice Deleted successfully",
      });
      setConfirmDeletePCLoading(false);
    }
  }, [deleteResponse]);

  const handleAddNotice = (isUpdated) => {
    const flag = visible ? false : true;
    setVisible(flag);
    if (isUpdated === true) {
      getRequest();
    }
  };

  const handleEditNotice = (isUpdated) => {
    const flag = visibleEdit ? false : true;
    !flag && setSelectedRecord(null);
    setVisibleEdit(flag);
    if (isUpdated === true) {
      getRequest();
    }
  };
  const editRecord = (record) => {
    setVisibleEdit(true);
    setSelectedRecord(record);
  };

  const deleteOk = (record) => {
    setConfirmDeletePCLoading(true);
    deleteRequest(null, API_METHODS.DELETE, `/admin/notice/${record.id}`);
  };

  const onPaginationChange = (page) => {
    getRequest(
      null,
      API_METHODS.GET,
      `/admin/notice?pageNumber=${page.current}`
    );
    setCurrentPage(page.current);
  };

  return (
    <Card
      title="Notices"
      extra={
        <Button type="default" onClick={handleAddNotice}>
          Add Notice
        </Button>
      }
    >
      {contextHolder}
      <TableComponent
        columns={columns}
        tableData={tableData}
        loading={responseData.isLoading}
        onPaginationChange={onPaginationChange}
        total={totalRecords}
        current={currentPage}
      />

      {visible && <AddNotice visible={visible} close={handleAddNotice} />}
      {visibleEdit && (
        <AddNotice
          visible={visibleEdit}
          selectedRecord={selectedRecord}
          close={handleEditNotice}
        />
      )}
    </Card>
  );
}

export default NoticeTable;
